import { Registration } from '~/apis/ssf';

export function formatPoints(points: number) {
  return points.toFixed(2);
}

// Sum of individual scores for a team, excluding withdrawn and reserve lifters.
export function teamScoreTotal(registrations: Registration[]) {
  return registrations
    .filter(r => r.state !== 'WITHDRAWN' && !r.is_reserve)
    .reduce((sum, r) => sum + (r.nomination_result ?? 0), 0);
}
